import React from "react";
import { Card as MUICard, CardContent } from "@mui/material";

type CardProps = {
  children?: React.ReactNode;
};

const Card = ({ children }: CardProps) => {
  return (
    <MUICard>
      <CardContent sx={{ minHeight: 112 }}>{children}</CardContent>
    </MUICard>
  );
};

export default Card;
